module.exports = __webpack_public_path__ + "media/images/pokerroom/redkings/join-bg-6496f390a2170407bfd0f9ee5a89cdee.jpg";